export const apiUrlLiffUrl = 'external_api/liff-url/';
export const apiUrlLineSegmentMsg = 'external_api/line/segment-msg/';
export const apiUrlLineSegmentCoupon = 'external_api/line/segment-coupon/';

